import { FormGroup } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import IOption from "common/models/IOption";
import TokenSession from "core/util/session/TokenSession";
import { ConditionTypeRegistry } from "../ConditionTypeRegistry";
import { IConditionType } from "../IConditionType";

interface IAuthenticationCondition {
	state: "anonymous" | "authenticated" | "allAllowed";
}

const options: Array<IOption<"anonymous" | "authenticated" | "allAllowed">> = [
	{value: 'anonymous', label: 'Anonymous'},
	{value: 'authenticated', label: 'Authenticated'},
	{value: 'allAllowed', label: 'Anonymous and Authenticated'}
];

const AuthenticationCondition: IConditionType<IAuthenticationCondition> = {
	type: 'authentication',
	label: 'Authentication',
	icon: IconNames.LOG_IN,
	evaluate: (value) => {
		switch(value.state) {
			case 'anonymous':
				return !TokenSession.isAuthenticated();
			case 'authenticated':
				return TokenSession.isAuthenticated();
			case 'allAllowed':
				return true;
			default:
				return true;
		}
	},
	
	renderPreview: (value) => {
		switch(value.state) {
			case 'anonymous' : return 'User is not logged in';
			case 'authenticated' : return 'User is logged in';
			case 'allAllowed' : return 'All users allowed';
			default: return '(configuration required)';
		}


	}, 
	renderField: (value, onChange) => {

		return (
			<FormGroup label="Required State" helperText="require end user to be either logged in or NOT logged in">
				<ButtonSelect
					options={options}
					onChange={(state) => onChange({...value, state})}
					value={value.state}
				/>
			</FormGroup>
		);
	}
};

export default ConditionTypeRegistry.register(AuthenticationCondition);



// WEBPACK FOOTER //
// ./src/common/form/fields/condition/conditionTypes/AuthenticationCondition.reg.tsx